export const HEADERS_SENT_PROCESSES = [
  { name: 'Nombre del proceso', key: 'name' },
  { name: 'Pruebas a aplicar', key: 'categories' },
  { name: 'Usuarios sin contestar', key: 'unanswered_ratio' },
]
